/**
 * Lead attribution helper.
 *
 * Captures marketing parameters (UTM tags, Google Ads gclid, Facebook fbclid)
 * and the landing page on the first visit, persists them in localStorage
 * (first-touch), and exposes them at form-submit time so the backend email and
 * GA4 can show where the lead came from.
 */

const UTM_KEYS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid',
  'fbclid',
]

const STORAGE_KEY = 'rp_lead_attribution'

function readStored () {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {}
  } catch (e) {
    return {}
  }
}

function writeStored (data) {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  } catch (e) {
    // localStorage may be unavailable (private mode) — ignore.
  }
}

/**
 * Capture attribution once per browser (first-touch). Existing values are kept,
 * so a later untagged pageview does not overwrite the original source.
 */
function capture () {
  const stored = readStored()

  let params = {}
  try {
    params = new URLSearchParams(window.location.search)
  } catch (e) {
    params = { get: () => null }
  }

  UTM_KEYS.forEach(key => {
    const value = params.get(key)
    if (value && !stored[key]) {
      stored[key] = value
    }
  })

  if (!stored.landing_page) {
    stored.landing_page = window.location.href
    stored.first_referrer = document.referrer || ''
  }

  writeStored(stored)

  return stored
}

// Run capture as soon as the module is loaded (i.e. on every page).
capture()

/**
 * Attribution payload to attach to a lead submission.
 *
 * @returns {Object}
 */
export function getAttribution () {
  const stored = readStored()

  return {
    page_url: window.location.href,               // page the form was submitted from
    referrer: document.referrer || '',
    landing_page: stored.landing_page || window.location.href,
    utm_source: stored.utm_source || '',
    utm_medium: stored.utm_medium || '',
    utm_campaign: stored.utm_campaign || '',
    utm_term: stored.utm_term || '',
    utm_content: stored.utm_content || '',
    gclid: stored.gclid || '',
    fbclid: stored.fbclid || '',
  }
}

export default getAttribution
